<!--Start topbar header-->
<header class="topbar-nav">
	<nav id="header-setting" class="navbar navbar-expand fixed-top">
		<div class="toggle-menu" (click)="toggleSidebar()"> <i class="zmdi zmdi-menu"></i>
		</div>
		
		<ul class="navbar-nav align-items-center right-nav-link ml-auto">
			<!-- <li ngbDropdown class="nav-item dropdown-lg">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic1" ngbDropdownToggle> <i class="zmdi zmdi-comment-outline align-middle"></i><span class="bg-danger text-white badge-up">12</span>
				</a>
				<div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
					<ul class="list-group list-group-flush">
						<li class="list-group-item d-flex justify-content-between align-items-center">New Messages <a href="javascript:;" class="extra-small-font">Clear All</a>
						</li>
						<li class="list-group-item">
							<a href="javaScript:;">
								<div class="media">
									<div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-5.png" alt="user avatar">
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">Jhon Deo</h6>
										<p class="msg-info">Lorem ipsum dolor sit amet...</p> <small>Today, 4:10 PM</small>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item">
							<a href="javaScript:;">
								<div class="media">
									<div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-6.png" alt="user avatar">
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">Sara Jen</h6>
										<p class="msg-info">Lorem ipsum dolor sit amet...</p> <small>Yesterday, 8:30 AM</small>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item">
							<a href="javaScript:;">
								<div class="media">
									<div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-7.png" alt="user avatar">
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">Dannish Josh</h6>
										<p class="msg-info">Lorem ipsum dolor sit amet...</p> <small>5/11/2018, 2:50 PM</small>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item">
							<a href="javaScript:;">
								<div class="media">
									<div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-8.png" alt="user avatar">
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">Katrina Mccoy</h6>
										<p class="msg-info">Lorem ipsum dolor sit amet.</p> <small>1/11/2018, 2:50 PM</small>
									</div>
								</div>
							</a>
						</li>
						<li class="list-group-item text-center"><a href="javaScript:;">See All Messages</a>
						</li>
					</ul>
				</div>
			</li> -->
			<li ngbDropdown class="nav-item dropdown-lg">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic2" ngbDropdownToggle> <i class="zmdi zmdi-notifications-active align-middle"></i><span class="bg-info text-white badge-up">{{notificationCount}}</span>
				</a>
				<div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="dropdown-menu-right">
					<ul class="list-group list-group-flush">
						<li class="list-group-item d-flex justify-content-between align-items-center">New Notifications <a href="javascript:;" (click)="GotoViewOrder()" class="extra-small-font">View All</a>
						</li>
						<li class="list-group-item" *ngFor="let row of rowData; let i = index">
							<a href="javaScript:;" (click)="GotoViewOrder()">
								<div class="media">
									<!-- <div class="avatar">
										<img class="align-self-start mr-3" src="assets/images/avatars/avatar-8.png" alt="user avatar">
									</div> -->
									<div class="avatar mr-2" style="position: relative; display: inline-block;">
										<div class="qty-circle-only" *ngIf="row.items?.length">
										  {{ row.items.length }}
										</div>
									</div>
									<div class="media-body">
										<h6 class="mt-0 msg-title">
											<span >
												Order ID : {{row.order.order_id}} || ({{ row.customer?.full_name || 'N/A' }})
											</span>
										</h6>
										<p class="msg-info">Amount : {{ row.order?.total_amount }} || Mode : {{ row.order?.payment_mode }}</p> <small>{{row.order.date_time}}</small>
									</div>
								</div>
							</a>
						</li>
						
					</ul>
				</div>
			</li>
			<li ngbDropdown class="nav-item">
				<a class="nav-link dropdown-toggle-nocaret position-relative" href="javascript:;" id="dropdownBasic4" ngbDropdownToggle> <span class="user-profile"><img src="assets/images/avatars/avatar-13.png" class="img-circle" alt="user avatar"></span>
				</a>
				<ul ngbDropdownMenu aria-labelledby="dropdownBasic1" class="dropdown-menu-right">
					<li ngbDropdownItem class="user-details">
						<a href="javaScript:;">
							<div class="media">
								<div class="avatar">
									<img class="align-self-start mr-3" src="assets/images/avatars/avatar-13.png" alt="user avatar">
								</div>
								<div class="media-body">
									<h6 class="mt-2 user-title">{{full_name}}</h6>
									<p class="user-subtitle">{{email}}</p>
								</div>
							</div>
						</a>
					</li>
					<li class="dropdown-divider"></li>
					<li ngbDropdownItem style="cursor: pointer;" (click)="Logout()"><i class="zmdi zmdi-power mr-3"></i>Logout</li>
				</ul>
			</li>
		</ul>
	</nav>
</header>
<!--End topbar header-->